@if (Vendor) {
  <div class="container-fluid mt-4 ps-4">
    <div class="row align-items-center">
      <div class="col d-flex justify-content-between align-items-center">
        <h2 class="mb-0">
          Sites {{ Vendor.legalName ? ' - ' + Vendor.legalName : '' }}
        </h2>
        <button class="btn btn-primary" (click)="assignSites()">
          Assign sites
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 pt-3" style="height: 500px">
        @if (suppliedGridQueryData) {
          <app-sites-grid
            [gridName]="'ClientMySites'"
            [suppliedQueryData]="suppliedGridQueryData"
            [ColumnIdToColumnActions]="ColumnIdToColumnActions"
            [(reloadGridData)]="reloadGrid"
            (actionEvent)="action($event)"
          ></app-sites-grid>
        }
      </div>
    </div>
  </div>
}
